import { useState } from "react";
import { Redirect, useParams } from "react-router-dom";
import { AnnouncementForm } from "../Forms";

export const AnnouncementFormPage = (props: { location: any }) => {
	const [redirect, setRedirect] = useState(false);
	const { id } = useParams<{ id?: string }>();

	if (redirect) {
		// Return to the exact list URL (filters, tab and page live in the query string)
		const returnUrl: string | undefined = props.location?.state?.returnUrl;
		if (returnUrl) {
			return <Redirect to={returnUrl} />;
		}

		return (
			<Redirect
				to={{
					pathname: "/anunturi",
					state: {
						searchTerm: props.location?.state?.searchTerm,
						currentPage: props.location?.state?.currentPage,
						pageSize: props.location?.state?.pageSize,
					},
				}}
			/>
		);
	}
	return (
		<AnnouncementForm
			location={props.location}
			setRedirect={setRedirect}
			announcementId={id}
		/>
	);
};
